import { useAuth } from "@/hooks/useAuth";
import { useTenant } from "@/hooks/useTenant";
import { useEffect } from "react";
import { useNavigate } from "react-router";

/** Redirects `/` → `/:firstTenantSlug` (authenticated) or `/login` (unauthenticated). */
const RootRedirect = () => {
  const { user, loading: authLoading } = useAuth();
  const { tenants, isLoading } = useTenant();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      void navigate("/login", { replace: true });
      return;
    }
    if (isLoading) return;
    if (tenants.length > 0) {
      void navigate(`/${tenants[0].slug}`, { replace: true });
    }
  }, [user, authLoading, tenants, isLoading, navigate]);

  // SIM-2347: belt-and-suspenders empty-state. The platform authorization gate now
  // prevents a user with zero tenant memberships (and no super_admin role) from ever
  // being issued a session, so the only way to reach here authenticated-with-zero-tenants
  // is a super_admin in an environment that has no tenants. Render a neutral message
  // instead of hanging forever on the loading shell.
  if (!authLoading && !isLoading && user && tenants.length === 0) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-2 px-6 text-center">
        <p className="text-foreground text-base font-medium">SimplySpark not available</p>
        <p className="text-muted-foreground text-sm">
          Your account isn't authorized. Contact your administrator if you believe this is a
          mistake.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <p className="text-muted-foreground text-sm">Loading...</p>
    </div>
  );
};

export default RootRedirect;
